import React__default from 'react';
import styled from 'styled-components';
import { T as Text } from '../../Text/Text-DKaGtBNT.js';
import { g as angleDown } from '../../LocalModules/storm-ui-icons/dist/esm/localIcons-EM4gOTGb-B7bhIt-r.js';
import { I as Icon } from '../../Icon/Icon-BAb4rBP0.js';

const PositionedIcon = /*#__PURE__*/styled(Icon).withConfig({
  componentId: "sc-storm-ui-30062554__sc-kfvljt-0"
})(["margin-inline-start:", ";"], ({
  theme
}) => theme.spacing.mini);
const DefaultFooter = ({
  label
}) => /*#__PURE__*/React__default.createElement(Text, null, label, /*#__PURE__*/React__default.createElement(PositionedIcon, {
  type: angleDown
}));

export { DefaultFooter as D };
//# sourceMappingURL=DefaultFooter-BBzbS8Hw.js.map
